import { Utility, utility_controller } from '../utility/utility_controller'
import intromedia_controller from './intro_media_controller'
// import IntroMediaView from './intro_media_view'
// import IntroRootView from './intro_root_view'

var intro_controller_new = {
	init: function (callback) {
		init(callback)
	},
	hide: function () {
		hide()
	},
	destroy: function () {
		destroy()
	},
	unbind: function () {
		unbind()
	},
	initHideAfter: function () {
		initHideAfter()
	},
	getBoundaries: function () {
		return {
			boundaryX: stateMap.boundaryX,
			boundaryY: stateMap.boundaryY,
		}
	},
	setReferences: function () {
		setReferences()
	},
	prepareBoundary: function () {
		prepareBoundary()
	},
	cancelLoading: function () {
		cancelLoading()
	},
}

export default intro_controller_new

var $mediaWrap
var particle = null
var $body
var requestAnimationFrameId

var stateMap = {
	boundaryX: 0,
	boundaryY: 0,
	intro_landscape: null,
	intro_portrait: null,
}

var configMap = {
	mediaScale: 115,
}

// for customizer!
window.laytheme.on('customizer_showintro', function () {
	// unbinding events first, because init might be called before intro was destroyed when quickly closing and opening intro section in customizer
	destroy(false)
	init()
})
window.laytheme.on('customizer_hideintro', function () {
	destroy(false)
	jQuery('body').removeClass('intro-loading')
})

var cancelLoading = function () {
	jQuery('body').removeClass('intro-loading')
	destroy(false)
}

var init = function () {
	// intro could have been hidden before because when you're in customizer, it will show and hide based on whether you are in the intro panel
	jQuery('#intro-region').removeClass('hide')
	jQuery('body').removeClass('intro-loading')
	if (!layData.is_frontpage) {
		return
	}
	if (!layData.intro_active) {
		return
	}

	// dont show intro if there is no text, no media, no svg overlay
	var showIntro = false

	if (Utility.orientation === 'landscape') {
		if (!jQuery.isEmptyObject(layData.intro_landscape)) {
			showIntro = true
		}
	} else {
		if (!jQuery.isEmptyObject(layData.intro_portrait)) {
			showIntro = true
		}
	}
	if (layData.intro_use_svg_overlay == true && layData.intro_svg_url != '') {
		showIntro = true
	}
	if (layData.intro_use_text_overlay == true && layData.intro_text != '') {
		showIntro = true
	}
	if (layData.intro_hide_on_phone && window.innerWidth < parseInt(layData.breakpoint, 10)) {
		showIntro = false
	}

	if (showIntro == false) {
		destroy()
		return
	}

	$body = jQuery('body')

	particle = new Particle(0, 0)

	setReferences()
	prepareBoundary()
	initHideAfter()
	sizeIntroMedia()
	jQuery('#intro-region').on('click', hide)
	jQuery('body').removeClass('intro-loading')

	// Disable scroll if setting is active
	if (layData.intro_disable_scroll == '1') {
		utility_controller.fixBody(true)
		// Add wheel event listener to hide intro on scroll
		jQuery(window).on('wheel', doWheel)
	}

	window.laytheme.on('orientationchanged', onOrientationChanged)

	setTimeout(function () {
		if (layData.intro_movement == true) {
			bindMove()
			animate()
		}
	}, 0)

	jQuery(window).on('resize', sizeIntroMedia)
	// Capture-phase native listener — catches scroll events from any
	// element in the tree (including overlay children that wouldn't
	// bubble to document). jQuery's `.on('scroll')` binds to document
	// directly which misses overlay-internal scrolls entirely.
	document.addEventListener('scroll', doScroll, true)
}

var setReferences = function () {
	$mediaWrap = jQuery('.intro .mediawrap')
	stateMap.intro_landscape = layData.intro_landscape
	stateMap.intro_portrait = layData.intro_portrait
}

var doScroll = function (event) {
	// On direct-load of a project / page overlay, html has
	// `overflow-y: hidden` and `window.scrollY` stays 0 — the actual
	// scroll happens inside the overlay element. A jQuery
	// `document.on('scroll')` binding does NOT bubble from a
	// scrolling overlay descendant, so we use capture-phase below
	// AND inspect `event.target.scrollTop` instead of `window.scrollY`
	// to hide the intro on overlay-internal scroll too.
	var t = event && event.target
	var scrolled = 0
	if (t && t !== document && t !== window && typeof t.scrollTop === 'number') {
		scrolled = t.scrollTop
	} else {
		scrolled = window.scrollY || document.documentElement.scrollTop || 0
	}
	if (scrolled > 10) {
		hide()
	}
}

var doWheel = function (e) {
	// Hide intro on mouse wheel scroll
	hide()
}

var onOrientationChanged = function () {
	initHideAfter()
}

var initHideAfter = function () {
	if (layData.is_customize == true) {
		return
	}
	var hide_after_time = parseInt(layData.intro_hide_after, 10)
	if (hide_after_time == 0) {
		return
	}

	// is video? hide after playback started
	// is image? hide after image loaded
	var type = stateMap.intro_portrait.type
	if (Utility.orientation === 'landscape') {
		var type = stateMap.intro_landscape.type
	}

	if (typeof type == 'undefined') {
		setTimeout(function () {
			hide()
		}, hide_after_time)
	} else {
		switch (type) {
			case 'video':
				var selector = Utility.orientation === 'landscape' ? '.intro video.intro-landscape-media' : '.intro video.intro-portrait-media'
				jQuery(selector).on('playing', function () {
					setTimeout(function () {
						hide()
					}, hide_after_time)
				})
				break
			default:
			case 'image':
				var selector = Utility.orientation === 'landscape' ? '.intro img.intro-landscape-media' : '.intro img.intro-portrait-media'
				if (jQuery(selector).length > 0) {
					jQuery(selector)[0].onload = function () {
						setTimeout(function () {
							hide()
						}, hide_after_time)
					}
				}
				break
		}
	}
}

var map = function (value, istart, istop, ostart, ostop) {
	return ostart + (ostop - ostart) * ((Math.min(istop, Math.max(istart, value)) - istart) / (istop - istart))
}

var prepareBoundary = function () {
	// 100vh is not window.innerHeight on iPhone, that's why i use mediaDivHeight:
	var mediaDivHeight = jQuery('.intro .mediawrap').height()
	var mediaWidth = 0,
		mediaHeight = 0

	if ($mediaWrap.hasClass('h100')) {
		mediaHeight = (mediaDivHeight * configMap.mediaScale) / 100
		if (Utility.orientation === 'landscape') {
			mediaWidth = (mediaHeight * stateMap.intro_landscape.width) / stateMap.intro_landscape.height
		} else {
			mediaWidth = (mediaHeight * stateMap.intro_portrait.width) / stateMap.intro_portrait.height
		}
	} else {
		mediaWidth = ($body.innerWidth() * configMap.mediaScale) / 100
		if (Utility.orientation === 'landscape') {
			mediaHeight = (mediaWidth * stateMap.intro_landscape.height) / stateMap.intro_landscape.width
		} else {
			mediaHeight = (mediaWidth * stateMap.intro_portrait.height) / stateMap.intro_portrait.width
		}
	}
	stateMap.boundaryX = (mediaWidth - $body.innerWidth()) / 2
	stateMap.boundaryY = (mediaHeight - mediaDivHeight) / 2

	stateMap.boundaryX -= 2
	stateMap.boundaryY -= 2
}

var max = 1

var bindMove = function () {
	prepareBoundary()
	if (!Utility.isTouchDevice) {
		jQuery(window).on('mousemove', doMouseMove)
	} else {
		window.addEventListener('deviceorientation', doDeviceOrientation)
	}
}

var doMouseMove = function (e) {
	var x = map(e.clientX, 0, $body.innerWidth(), max, -max)
	var y = map(e.clientY, 0, window.innerHeight, max, -max)

	particle.updateDestination(x, y)
}

var doDeviceOrientation = function (e) {
	var x = e.gamma
	var y = e.beta

	if (window.orientation == 90) {
		x = map(e.beta, -45, 45, max, -max)
		y = map(-e.gamma, -20, 70, max, -max)
	} else if (window.orientation == -90) {
		x = map(-e.beta, -45, 45, max, -max)
		y = map(e.gamma, -20, 70, max, -max)
	} else if (window.orientation == 180) {
		x = map(-e.gamma, -45, 45, max, -max)
		y = map(-e.beta, -20, 70, max, -max)
	} else {
		x = map(e.gamma, -45, 45, max, -max)
		y = map(e.beta, -20, 70, max, -max)
	}

	particle.updateDestination(x, y)
}

var animate = function () {
	particle.update()
	$mediaWrap.css({
		transform: 'translate(' + particle.x + 'px, ' + particle.y + 'px)',
		'-webkit-transform': 'translate(' + particle.x + 'px, ' + particle.y + 'px)',
	})
	requestAnimationFrameId = requestAnimationFrame(animate)
}

// destroy and unbind
var destroy = function (emptyHTML) {
	if (emptyHTML == undefined) {
		emptyHTML = true
	}
	jQuery('body').removeClass('intro-enabled').addClass('intro-disabled')
	// when using customizer, i dont remove the html, because i want to re-show the intro when opening intro customizer tab
	if (emptyHTML) {
		jQuery('#intro-region').html('').addClass('hide')
	} else {
		jQuery('#intro-region').addClass('hide')
	}
	// Re-enable scroll if it was disabled
	if (layData.intro_disable_scroll == '1') {
		utility_controller.unfixBody()
		jQuery(window).off('wheel', doWheel)
	}
	window.laytheme.off('orientationchanged', onOrientationChanged)
	cancelAnimationFrame(requestAnimationFrameId)
	window.removeEventListener('deviceorientation', doDeviceOrientation)
	jQuery(window).off('mousemove', doMouseMove)
	jQuery(window).off('resize', sizeIntroMedia)
	clearTimeout(hideTimeout)
}

var sizeIntroMedia = function () {
	intromedia_controller.setW100H100Mediawrap()
	intromedia_controller.setSizes()
	intromedia_controller.setSizingClassName()
	prepareBoundary()
}

var hideTimeout

var hide = function (callback) {
	// why did we have a hide timeout??
	// hideTimeout = setTimeout(function() {
	if (layData.intro_transition_duration == 0) {
		destroy()
	} else {
		jQuery('.intro').on('transitionend', function () {
			destroy()
		})
		jQuery('.intro').addClass('animatehide')
	}

	if (typeof callback == 'function') {
		callback()
	}

	document.removeEventListener('scroll', doScroll, true)
	// Re-enable scroll if it was disabled
	if (layData.intro_disable_scroll == '1') {
		utility_controller.unfixBody()
		jQuery(window).off('wheel', doWheel)
	}
	// }, 0);
}

// PARTICLE
;(function () {
	function Particle(x, y) {
		// range = [-boundary, boundary]
		this.x = x
		this.y = y

		// range = [-1, 1]
		this.virtualX = x
		this.virtualY = y
		this.destX = x
		this.destY = y

		this.xvelocity = 0
		this.yvelocity = 0
	}

	Particle.prototype.update = function () {
		var boundaries = intro_controller_new.getBoundaries()

		this.xvelocity = this.destX - this.virtualX
		this.yvelocity = this.destY - this.virtualY

		if (Math.abs(this.xvelocity) > 0.002) {
			this.xvelocity *= 0.03
		}
		if (Math.abs(this.yvelocity) > 0.002) {
			this.yvelocity *= 0.03
		}

		this.virtualX += this.xvelocity
		this.virtualY += this.yvelocity

		this.x = Math.min(1, Math.max(-1, this.virtualX)) * boundaries.boundaryX
		this.y = Math.min(1, Math.max(-1, this.virtualY)) * boundaries.boundaryY
	}

	Particle.prototype.updateDestination = function (x, y) {
		this.destX = x
		this.destY = y
	}

	window.Particle = Particle
})()
